<template>
	<fragment>
		<HeadingSVG class="unfixed" imgName="little-bummer" altText="Little Bummer" />
		<div class="wysiwyg-content desciption" v-html="description" />
		<MarqueeButton class="little-bummer" :action="advance">{{ button_text }}</MarqueeButton>
	</fragment>
</template>

<script>
import HeadingSVG from '@/components/base/HeadingSVG';
import MarqueeButton from "@/components/base/MarqueeButton";

export default {
	name: 'Little',
	components: {
		HeadingSVG,
		MarqueeButton,
	},
	props: {
		id: {
			type: Number,
			required: true,
		},
		button_text: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
	},
	methods: {
		advance() {
			this.$store.dispatch("global/analytics/trackEvent", { ec: "InGame", el: "LittleBummer", ea: `${this.title}` });
			this.$parent.complete();
		},
	},
	mounted() {
		this.$store.dispatch("sound/fx/play", { id: "little_bummer" });
	},
};
</script>

<style lang="scss" scoped>
	.marquee-btn { margin: 20px 0 0; }
</style>
